import * as React from 'react';
import { colors } from '../styles/colors';

interface IProps {
    isBold: boolean;
    style?: React.CSSProperties;
}

export const NotificationBodyText: React.SFC<IProps> = ({ isBold, children, style }) => (
    <p style={{ ...(isBold ? unreadStyle : {}), ...(isBold ? {} : { opacity: 0.7 }), ...bodyTextStyle, ...style }}>{children}</p>
);

const bodyTextStyle: React.CSSProperties = {
    fontSize: 14,
    color: colors.DARK_BACKGROUND,
    marginBottom: 6,
    cursor: 'pointer'
};
const unreadStyle: React.CSSProperties = {
    fontWeight: 'bolder'
};



// WEBPACK FOOTER //
// ./src/SharedComponents/NotificationBodyText.tsx